// app/javascript/controllers/submit_spinner_controller.js
import { Controller } from "@hotwired/stimulus"

// Mostra uno spinner al posto del testo del bottone al submit di form nativi
// (data: { turbo: false }), per segnalare l'attesa durante operazioni lente
// lato server (es. generazione di testo con AI).
export default class extends Controller {
  static targets = ["button"]
  static values = { label: String }

  submit() {
    const button = this.buttonTarget

    button.disabled = true
    button.innerHTML = `<i class="fas fa-spinner fa-spin me-1"></i> ${this.labelValue}`
  }
}
